<div class="reset-success-container">
  <img src="assets/zlogo.svg" alt="PIMS Logo" class="absolute top-8 left-8 w-24" />
  <div class="success-content">
    <h1 class="text-text-strong mb-4 text-[36px] font-bold" i18n="@@resetSuccessTitle">Password Reset</h1>
    <svg xmlns="http://www.w3.org/2000/svg" width="7em" height="7em" viewBox="0 0 24 24">
      <path
        class="fill-success-icon"
        d="M19.78 2.2L24 6.42L8.44 22L0 13.55l4.22-4.22l4.22 4.22zm0 2.8L8.44 16.36l-4.22-4.17l-1.41 1.36l5.63 5.62L21.19 6.42z" />
    </svg>
    <p class="text-text-strong mb-6 text-[32px] font-extralight" i18n="@@resetSuccessMessage">
      Password has been reset successfully
    </p>
    <button (click)="goToLogin()" class="btn-primary mt-4" i18n="@@resetSuccessLoginButton">LOGIN</button>
  </div>
</div>

<div class="screen-ellipse"></div>
